import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { plainToClass } from "class-transformer";

import { AsyncJobDialogBase } from '../async-job-base/async-job-base.dialog';
import { ImportAsyncJobDialogBase } from '../async-job-base/import-async-job-base.dialog';
//import { CopySiteService } from '../../services/copy-site.service';
import { ImportMetadataService } from '../../services/import-metadata.service';
import { AsyncJobService } from '../../services/async-job.service';
import { AsyncJob } from '../../models/async-job.model';
//import { XmlFileFormatEnum } from '../../enums/xml-file-format.enum';
import { CurrentSiteService } from '../../services/current-site.service';
import { XmlFileFormatEnum } from '../../enums/xml-file-format.enum';
import { ImportFormDefinitionsMetrics } from '../../models/export-import/import-form-definitions-metrics.model';

@Component({
    selector: 'app-import-form-definition',
    templateUrl: './import-form-definition.dialog.html',
    styleUrls: ['./import-form-definition.dialog.scss'],
    standalone: false
})
export class ImportFormDefinitionDialog extends ImportAsyncJobDialogBase implements OnInit, AfterViewInit {
    // Properties.
    // File-related properties.
    @ViewChild('file') file;
    private fileSet: Set<File> = new Set();
    private selectedFileName: string = null;

    private numFormDefsImported: number = 0;
    private importFormDefinitionsMetrics: ImportFormDefinitionsMetrics = null;

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<ImportFormDefinitionDialog>,
        @Inject(MAT_DIALOG_DATA) public initObjectNotPresentlyUsed: any,
        public dialog: MatDialog,
        //private copySiteService: CopySiteService,
        private importMetadataService: ImportMetadataService,
        private injectedAsyncJobService: AsyncJobService,
        private currentSiteService: CurrentSiteService)
    {
        super(injectedAsyncJobService);

        dialogRef.disableClose = true; // Disable closing the dialogue when the user clicks on the page.

        return;
    }

    // Implement a base class's abstract method.
    public get ComponentClassName(): string {
        return 'ImportFormDefinitionDialog';
    }

    // Life cycle methods.
    public ngOnInit(): void {
        return;
    }

    public ngAfterViewInit(): void {
        return; // Note:  a breakpoint can be set here to see if property 'file' is resolved.
    }

    // Methods called by my HTML code.
    public get Title(): string {
        // Note:  in the future the title might refer to 'Definitions', plural.
        return ('Import Form Definitions');
    }

    public get SelectedFileName(): string {
        return (this.selectedFileName != null ? this.selectedFileName : 'No file selected');
    }
    public get FileSelected(): boolean {
        let bFileSelected: boolean = (this.fileSet.size > 0);

        return (bFileSelected);
    }

    public get DismissButtonTitle(): string {
        return ('Dismiss');
    }

    public get ExecutionSummaryText(): string {
        let summaryText: string = this.deriveExecutionSummaryText(this.importFormDefinitionsMetrics);

        return (summaryText);
    }

    // Handle control events.
    public selectImportFile(): void {
        this.file.nativeElement.click(); // Cause the hidden file control to open.

        return;
    }
  
    public onFileAdded(): void {
        // Clear any previous file.
        this.fileSet = new Set()

        // Save the selected file.
        const files: { [key: string]: File } = this.file.nativeElement.files;

        for (let key in files) {
            if (!isNaN(parseInt(key))) {
                let selectedFile: File = files[key];

                this.fileSet.add(selectedFile);

                this.selectedFileName = selectedFile.name;
            }
        }

        return;
    }

    public startStructureImport(): void {
        // Initiate the import.
        let arrFiles: File[] = Array.from(this.fileSet);

        if (arrFiles.length > 0) {
            //this.copySiteService.importFormDefinitions(arrFiles, this.currentSiteService.Site.id, XmlFileFormatEnum.VERBOSE_FORMAT).then(asyncJob => {
            this.importMetadataService.importFormDefinitions(arrFiles, this.currentSiteService.Site.id, XmlFileFormatEnum.VERBOSE_FORMAT).then(asyncJob => {
                this.startMonitoringJob(asyncJob, this.jobCompletedArrowFunction);
            });
        }

        return;
    }

    public dismissClicked(): void {
        this.dialogRef.close(this.numFormDefsImported);
    }

    public cancelClicked(): void {
        this.dialogRef.close(null);
    }

    // Private methods.
    private jobCompletedArrowFunction = (asyncJob: AsyncJob): void => {
        //this.numFormDefsImported = this.parseResultObjectId(asyncJob);
        // If there is no error, try to parse the job completion summary.
        if ((this.jobCompletedMessageText != null) && (this.jobCompletedMessageText.trim() != '')) {
            let jobCompletedMessageJson: Object = JSON.parse(this.jobCompletedMessageText);
            this.importFormDefinitionsMetrics = new ImportFormDefinitionsMetrics(jobCompletedMessageJson);
        }
    }
}
